import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AnnotationIdContextType {
  annotationIdFromList: string | null;
  setAnnotationIdFromList: (id: string | null) => void;
}

const AnnotationIdContext = createContext<AnnotationIdContextType | undefined>(undefined);

export const useAnnotationIdContext = () => {
  const context = useContext(AnnotationIdContext);
  if (context === undefined) {
    throw new Error('useAnnotationIdContext must be used within an AnnotationIdProvider');
  }
  return context;
};

interface AnnotationIdProviderProps {
  children: ReactNode;
}

export const AnnotationIdProvider: React.FC<AnnotationIdProviderProps> = ({ children }) => {
  const [annotationIdFromList, setAnnotationIdFromList] = useState<string | null>(null);

  return (
    <AnnotationIdContext.Provider value={{ annotationIdFromList, setAnnotationIdFromList }}>
      {children}
    </AnnotationIdContext.Provider>
  );
}; 